import React from 'react';
const TestimonialsSection = () => {
  return <div className="mb-16" id="testimonials" data-id="element-485">
      <div className="relative mb-12" data-id="element-486">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/7a9k4VBvRebdLL1R1JJ9Td/Untitled_design_%2861%29.png" alt="People showing MyoQuell patches and application" className="w-full h-auto rounded-lg md:shadow-lg object-cover" style={{
        maxHeight: '500px',
        width: '100%',
        objectPosition: 'center'
      }} data-id="element-487" />
      </div>
      {/* Decorated section title */}
      <div className="relative flex items-center mb-10" data-id="element-488">
        <div className="hidden md:block h-0.5 flex-grow bg-gradient-to-r from-transparent via-green-200 to-transparent" data-id="element-489"></div>
        <h2 className="text-4xl font-bold text-green-600 px-5 md:px-8 relative" data-id="element-490">
          <span className="relative z-10" data-id="element-491">Real Women, Real Results</span>
          <span className="absolute -bottom-2 left-0 right-0 h-3 bg-yellow-100 opacity-50 -z-0 skew-x-3" data-id="element-492"></span>
        </h2>
        <div className="hidden md:block h-0.5 flex-grow bg-gradient-to-r from-transparent via-green-200 to-transparent" data-id="element-493"></div>
      </div>
      <div className="grid md:grid-cols-2 gap-6 mb-12" data-id="element-494">
        <div className="bg-white p-8 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300 border border-gray-100 transform hover:scale-[1.02]" data-id="element-495">
          <div className="flex items-center mb-5" data-id="element-496">
            <div className="bg-yellow-500 text-white rounded-full p-1 mr-4 flex-shrink-0" data-id="element-497">
              ⭐⭐⭐⭐⭐
            </div>
            <img src="https://images.unsplash.com/photo-1566616213894-2d4e1baee5d8?ixlib=rb-1.2.1&auto=format&fit=crop&w=120&q=80" alt="Martha K." className="w-10 h-10 rounded-full object-cover mr-3 border-2 border-green-500" data-id="element-498" />
            <div data-id="element-499">
              <p className="font-bold text-xl" data-id="element-500">Martha K., 58</p>
              <p className="text-base text-gray-600" data-id="element-501">Verified Purchase</p>
            </div>
          </div>
          <p className="italic text-xl mb-4 leading-relaxed" data-id="element-502">
            "I canceled my knee surgery. My orthopedic surgeon asked what I was
            using!"
          </p>
          <p className="text-gray-700 text-lg leading-relaxed" data-id="element-503">
            After 3 years of worsening knee pain, I was scheduled for surgery
            next month. Two weeks of using MyoQuell and I called to cancel. My
            doctor was shocked at my mobility improvement.
          </p>
        </div>
        <div className="bg-white p-8 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300 border border-gray-100 transform hover:scale-[1.02]" data-id="element-504">
          <div className="flex items-center mb-5" data-id="element-505">
            <div className="bg-yellow-500 text-white rounded-full p-1 mr-4 flex-shrink-0" data-id="element-506">
              ⭐⭐⭐⭐⭐
            </div>
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/235vKRpgcBUSL2JGKEbq9u/7a8e14c5-4fc1-42bc-90c5-b3b69d44dffd.png" alt="Jennifer T." className="w-10 h-10 rounded-full object-cover mr-3 border-2 border-green-500" data-id="element-507" />
            <div data-id="element-508">
              <p className="font-bold text-xl" data-id="element-509">Jennifer T., 49</p>
              <p className="text-base text-gray-600" data-id="element-510">Verified Purchase</p>
            </div>
          </div>
          <p className="italic text-xl mb-4 leading-relaxed" data-id="element-511">
            "First time I've slept through the night in years."
          </p>
          <p className="text-gray-700 text-lg leading-relaxed" data-id="element-512">
            The nighttime pain was the worst. I'd wake up 3-4 times every night.
            With MyoQuell, I apply a patch before bed and sleep soundly until
            morning. My energy levels have completely changed.
          </p>
        </div>
        <div className="bg-white p-8 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300 border border-gray-100 transform hover:scale-[1.02]" data-id="element-513">
          <div className="flex items-center mb-5" data-id="element-514">
            <div className="bg-yellow-500 text-white rounded-full p-1 mr-4 flex-shrink-0" data-id="element-515">
              ⭐⭐⭐⭐⭐
            </div>
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/vC7wFyNugBHcJziKcR7Zry/55769e5b-56ba-4d85-ab0e-cad5e599a989.png" alt="Patricia M." className="w-10 h-10 rounded-full object-cover mr-3 border-2 border-green-500" data-id="element-516" />
            <div data-id="element-517">
              <p className="font-bold text-xl" data-id="element-518">Patricia M., 61</p>
              <p className="text-base text-gray-600" data-id="element-519">Verified Purchase</p>
            </div>
          </div>
          <p className="italic text-xl mb-4 leading-relaxed" data-id="element-520">
            "I'm gardening again after five years!"
          </p>
          <p className="text-gray-700 text-lg leading-relaxed" data-id="element-521">
            My garden used to be my pride and joy, but kneeling became
            impossible. These patches have given me back my favorite hobby. I
            can kneel, stand, and work for hours without pain.
          </p>
        </div>
        <div className="flex justify-center items-center" data-id="element-522">
          <div className="max-w-md" data-id="element-523">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/xi4A147Eaft2YSUf2peRMm/44ba9a17-d6aa-44f3-8496-366286670d6f.png" alt="Senior woman gardening without knee pain" className="w-full h-auto rounded-lg md:shadow-lg" data-id="element-524" />
          </div>
        </div>
      </div>
      {/* Floating testimonial badge - visible on scroll */}
      <div className="fixed bottom-24 right-4 bg-white p-3 rounded-lg shadow-lg border-2 border-green-200 max-w-xs z-40 hidden md:block" data-id="element-525">
        <div className="flex items-start" data-id="element-526">
          <div className="bg-yellow-500 text-white rounded-full p-1 mr-3 flex-shrink-0" data-id="element-527">
            ⭐⭐⭐⭐⭐
          </div>
          <div data-id="element-528">
            <div className="flex items-center mb-2" data-id="element-529">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/bdWaWVNEFUGDZ8MCDSW1N3/45fcd326-1ae7-4fdb-bcce-f013e6ef63be.png" alt="Carol W." className="w-10 h-10 rounded-full object-cover mr-3 border-2 border-green-500" data-id="element-530" />
              <p className="text-xs text-gray-600" data-id="element-531">
                Carol W., 56 (Verified Buyer)
              </p>
            </div>
            <p className="font-medium text-gray-800 text-sm" data-id="element-532">
              "These patches changed my life! Walking without pain for the first
              time in 10 years."
            </p>
          </div>
        </div>
      </div>
      <div className="mt-16" data-id="element-533">
        <div className="relative flex items-center mb-8" data-id="element-534">
          <div className="hidden md:block h-0.5 flex-grow bg-gradient-to-r from-transparent via-green-200 to-transparent" data-id="element-535"></div>
          <h3 className="text-3xl font-bold px-5 relative" data-id="element-536">
            <span className="relative z-10" data-id="element-537">
              See How Our Customers Use MyoQuell
            </span>
            <span className="absolute -bottom-2 left-0 right-0 h-3 bg-green-100 opacity-50 -z-0 skew-x-3" data-id="element-538"></span>
          </h3>
          <div className="hidden md:block h-0.5 flex-grow bg-gradient-to-r from-transparent via-green-200 to-transparent" data-id="element-539"></div>
        </div>
        {/* Main image - full width on both mobile and desktop */}
        <div className="rounded-lg shadow-md md:shadow-xl overflow-hidden mb-8 md:transform md:hover:scale-[1.01] transition-transform duration-300" data-id="element-540">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/857iQsRNyWj8i1pe1zmc7J/6e56b577-4be8-4f15-983d-5a9693475482.png" alt="Person applying MyoQuell patch to knee" className="w-full h-auto object-cover" style={{
          display: 'block'
        }} data-id="element-541" />
          <div className="bg-white p-4 border-t" data-id="element-542">
            <p className="text-center text-base text-gray-600 italic" data-id="element-543">
              Application is simple - just peel and place directly on the
              painful area
            </p>
          </div>
        </div>
        {/* Image gallery - responsive layout */}
        <div className="grid grid-cols-2 md:grid-cols-3 gap-6 mb-10" data-id="element-544">
          <div className="rounded-lg shadow-md overflow-hidden col-span-1 group" data-id="element-545">
            <div className="overflow-hidden" data-id="element-546">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/orGjPZ9MsrtLtnL5WTgq7y/IMG_8701.png" alt="MyoQuell Herbal Knee Patches package and patch" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" style={{
              display: 'block',
              aspectRatio: '1/1'
            }} data-id="element-547" />
            </div>
            <div className="bg-white p-3" data-id="element-548">
              <p className="text-sm text-gray-600 text-center" data-id="element-549">
                The packaging and patches
              </p>
            </div>
          </div>
          <div className="rounded-lg shadow-md overflow-hidden col-span-1 md:col-span-2 row-span-1 group" data-id="element-550">
            <div className="overflow-hidden" data-id="element-551">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/7BAxQF1XrjmrFMAi7AVGY1/IMG_8498.png" alt="MyoQuell patches applied to both knees" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" style={{
              display: 'block'
            }} data-id="element-552" />
            </div>
            <div className="bg-white p-3" data-id="element-553">
              <p className="text-sm text-gray-600 text-center" data-id="element-554">
                MyoQuell can be used on both knees simultaneously
              </p>
            </div>
          </div>
          <div className="rounded-lg shadow-md overflow-hidden col-span-2 md:col-span-3 group" data-id="element-555">
            <div className="overflow-hidden" data-id="element-556">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/nXrU9MrQXKoXaeNbfLb8yK/Screenshot_2025-09-11_at_17.53.43.png" alt="MyoQuell patch being applied to knee" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" style={{
              display: 'block'
            }} data-id="element-557" />
            </div>
            <div className="bg-white p-3" data-id="element-558">
              <p className="text-sm text-gray-600 text-center mb-3" data-id="element-559">
                The patch is thin and discreet - wear it under clothing
              </p>
              <a href="https://myoquell.com/products/escape-knee-pain-with-myoquell-herbal-patches" className="bg-gradient-to-r from-green-600 to-green-500 hover:from-green-700 hover:to-green-600 text-white font-bold py-3 px-6 rounded-lg text-base block text-center transition-colors shadow-md mx-auto w-4/5" target="_blank" rel="noopener noreferrer" data-id="element-560">
                GET YOUR PATCHES TODAY →
              </a>
            </div>
          </div>
        </div>
        <div className="bg-green-50 p-8 rounded-lg mb-10 shadow-md border border-green-100 transform hover:scale-[1.01] transition-transform duration-300" data-id="element-561">
          <div className="flex items-start" data-id="element-562">
            <div className="text-5xl text-green-600 mr-4" data-id="element-563">"</div>
            <div data-id="element-564">
              <p className="text-xl font-medium mb-5 leading-relaxed" data-id="element-565">
                I was skeptical about a patch, but after just one application, I
                felt the difference. Now I don't go anywhere without them!
              </p>
              <div className="flex items-center" data-id="element-566">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/4hrP3yRGzPji9VGEen71zt/08697923-1101-4b2b-b95c-22f468ea5db2.png" alt="Robert D." className="w-16 h-16 rounded-full object-cover mr-4 border-2 border-green-500" data-id="element-567" />
                <div data-id="element-568">
                  <p className="font-bold text-lg" data-id="element-569">Robert D., 64</p>
                  <p className="text-base text-gray-600" data-id="element-570">Verified Purchase</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="mt-14" data-id="element-571">
        <div className="relative flex items-center mb-8" data-id="element-572">
          <div className="hidden md:block h-0.5 flex-grow bg-gradient-to-r from-transparent via-green-200 to-transparent" data-id="element-573"></div>
          <h3 className="text-3xl font-bold px-5 relative" data-id="element-574">
            <span className="relative z-10" data-id="element-575">The Science</span>
            <span className="absolute -bottom-2 left-0 right-0 h-3 bg-blue-100 opacity-50 -z-0 skew-x-3" data-id="element-576"></span>
          </h3>
          <div className="hidden md:block h-0.5 flex-grow bg-gradient-to-r from-transparent via-green-200 to-transparent" data-id="element-577"></div>
        </div>
        <div className="prose prose-xl max-w-none mb-8" data-id="element-578">
          <p className="text-xl leading-relaxed" data-id="element-579">
            Studies show topical capsaicin reduces osteoarthritis pain by 50%.
            Research confirms the penetration enhancers deliver 10x better
            absorption than standard topicals.
          </p>
        </div>
        <div className="bg-green-50 border border-green-200 p-8 rounded-lg shadow-md transform hover:scale-[1.01] transition-transform duration-300" data-id="element-580">
          <div className="flex items-center mb-4" data-id="element-581">
            <div className="w-16 h-16 bg-green-600 rounded-full flex items-center justify-center text-white mr-5 flex-shrink-0" data-id="element-582">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-583">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" data-id="element-584" />
              </svg>
            </div>
            <h3 className="text-2xl font-bold" data-id="element-585">
              30-Day "Walk Without Pain" Guarantee
            </h3>
          </div>
          <div className="prose prose-xl max-w-none" data-id="element-586">
            <p className="mb-4 text-xl leading-relaxed" data-id="element-587">
              Try MyoQuell for 30 days. If you're not walking easier, sleeping
              better, and living fuller – get every penny back. No questions
              asked. Keep the bonuses.
            </p>
            <p className="italic text-xl leading-relaxed" data-id="element-588">
              That's how confident we are.
            </p>
          </div>
        </div>
      </div>
    </div>;
};
export default TestimonialsSection;